'use client';

import type { FC } from 'react';

import useIsMobile from '@hyex/utils/hooks/useIsMobile';

import ArrowCarousel from '@hyex/modules/shared/Carousels/ArrowCarousel';
import NavCarousel from '@hyex/modules/shared/Carousels/NavCarousel';
import { ProductCategory } from '@hyex/dxp/types/store/Product/ProductCategory';
import { BlogCategory } from '@hyex/dxp/types/blog/Category';

type PropTypes = {
  items: BlogCategory[] | ProductCategory[];
  slug?: string;

  isProductCategories?: boolean;
};

const CategoriesNavigationCarousel: FC<PropTypes> = ({
  items,
  slug,
  isProductCategories = false,
}) => {
  const isMobile = useIsMobile(1340);

  const blogCategories = (
    <NavCarousel<BlogCategory>
      isMobile={isMobile}
      baseHref={'/learn'}
      subHref={'category'}
      items={(items as BlogCategory[]).filter((item) => !item.isSubcategory)}
      slug={slug}
      fieldName="name"
      indexHref="/learn"
    />
  );

  const productCategories = (
    <NavCarousel<ProductCategory>
      fieldName="title"
      isMobile={isMobile}
      baseHref={'/store'}
      items={(items as ProductCategory[]).filter((item) => !item.isSubcategory)}
      slug={slug}
      indexHref="/store"
    />
  );

  return (
    <>
      <ArrowCarousel
        slides={() => (isProductCategories ? <>{productCategories}</> : <>{blogCategories}</>)}
        alwaysShowArrows={false}
        wrapperClassName={'categories-nav-wrapper'}
        containerClassName="categories-container"
        parentClassName={'categories-nav'}
        options={{ containScroll: 'trimSnaps', dragFree: true }}
      />
    </>
  );
};

export default CategoriesNavigationCarousel;
